// extracted by mini-css-extract-plugin
module.exports = {"container":"IntroPage_container__248Pu","title":"IntroPage_title__3a-s3","content":"IntroPage_content__eE1XJ","in":"IntroPage_in__2-kSj"};